import React from "react";
import { Typography } from "@mui/material";
import MortgageSimulator from "../../simulator";
import { yearsAndMonths } from "../../utils";

export function formatPrincipal(
  sim: MortgageSimulator,
  c: (value: number, compact?: boolean) => string,
): string {
  return c(sim.principal, true);
}

export function formatInterestRate(sim: MortgageSimulator): string {
  return `${sim.mortgage.interestRate}%`;
}

export function formatTermLength(sim: MortgageSimulator): string {
  return yearsAndMonths(sim.mortgage.termMonths);
}

export function formatMonthlyPayment(
  sim: MortgageSimulator,
  c: (value: number, compact?: boolean) => string,
  isPrimary?: boolean,
): string | React.ReactNode {
  if (isPrimary) {
    return React.createElement(
      React.Fragment,
      null,
      c(sim.mortgage.desiredMonthlyPayment, true),
      " ",
      React.createElement(
        Typography,
        {
          variant: "body1",
          color: "text.secondary",
          sx: { display: "inline" },
        } as any,
        "/month",
      ),
    );
  }
  return `${c(sim.mortgage.desiredMonthlyPayment, true)}/month`;
}

export function getMonthlyPaymentTooltip(sim: MortgageSimulator): string {
  if (sim.interestOnly) {
    return "Interest Only Mortgage";
  }
  if (
    sim.additionalCapitalRepayments &&
    !sim.reduceTermOnAdditionalCapitalRepayment
  ) {
    return "Desired Monthly Mortgage Payment";
  }
  return "Monthly Mortgage Payment";
}
